import BaseStorageHandler from "./BaseStorageHandler";
import BaseModel from "../models/BaseModel";

import Logger from "../Logger";
import ZipStorageHandler from "./ZipStorageHandler";
import ProjectMetadata from "../models/ProjectMetadata";

const VERSION = 15;

const PROJECT_ITEMS = "projectItems"; // no itx
const PROJECT_ITEMS_BLOBS = "projectItemsblobs"; // no itx
const PROJECTS = "projects"; // no itx
const PRODDATACACHE = "proddatacache"; // no itx
const IMAGEDATACACHE = "imagedatacache"; // no itx
const METADATACACHE = "metadatacache"; // no itx
const VOLTUSCSVCACHE = "voltuscsvcache"; // no itx
const PDFSTORAGE = "pdfstorage"; // no itx

const logger = new Logger();

class LocalStorageHandler implements BaseStorageHandler {
  get isLocalStorgeHandle() {
    return true;
  }

  projectId: string = "";
  db: IDBDatabase | undefined = undefined;

  async ensureDbOpen(): Promise<boolean> {
    if (this.db) {
      return true;
    }

    await this.initializeDB();
    return this.db != undefined;
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // Project Items
  ///////////////////////////////////////////////////////////////////////////////////

  async deleteProjectItems(projectId: string): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([PROJECT_ITEMS_BLOBS], "readwrite"); // no itx

        const objectStoreItemsBlobs = transaction.objectStore(PROJECT_ITEMS_BLOBS);
        const request = objectStoreItemsBlobs.delete(projectId);

        request.onsuccess = (e: any) => {
          resolve(true);
        };

        request.onerror = () => {
          resolve(false);
        };
      });
    }
    return false;
  }

  saveData = async (item: BaseModel): Promise<boolean> => {
    logger.error("saveData should not be called");
    return false;
  };

  async saveProjectItems2(projectId: string, blob: Blob): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([PROJECT_ITEMS_BLOBS], "readwrite");
        const objectStore = transaction.objectStore(PROJECT_ITEMS_BLOBS);

        // const data = project.toJSON();
        const requestUpdate = objectStore.put({ id: projectId, blob: blob });

        requestUpdate.onsuccess = () => {
          resolve(true);
        };
        requestUpdate.onerror = (event) => {
          if (event?.target) {
            logger.log("error: ", event.target);
            resolve(true);
          }
        };
      });
    } else {
      return false;
    }
  }

  async loadDeletedIds(): Promise<boolean> {
    const transaction = this.db!.transaction([PROJECT_ITEMS_BLOBS]);
    const objectStore = transaction.objectStore(PROJECT_ITEMS_BLOBS);

    const data = await this.loadData(objectStore, state.projectMetadata.id, undefined);
    state.objectRegistry.deletedIds = data?.deletedIds || [];
    return true;
  }

  async loadData(objectStore: IDBObjectStore, id: string | undefined, parentId: string | undefined): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (id) {
        const request = objectStore.get(this.projectId + "_" + id);
        request.onsuccess = () => {
          // logger.log(`loaded single item from DB ${id}`, request.result);
          resolve(request.result);
        };

        request.onerror = (event) => {
          logger.error(`load single item failed: ${id}`, event);
          resolve(undefined);
        };
      } else if (parentId) {
        const myIndex: IDBIndex = objectStore.index("parentId");
        const request = myIndex.getAll(parentId);

        // objectStore.openCursor()
        request.onsuccess = (event) => {
          const l = (event.target as any).result.length;
          // logger.log(`loaded collection from DB ${parentId} ${l}`);
          resolve((event.target as any).result);
        };

        request.onerror = (event) => {
          logger.error(`loaded load collection failed from DB ${id}`, request.result);
          resolve([]);
        };
      } else {
        logger.error(`parameter erroe`);
        resolve([]);
      }
    });
  }

  async loadProjectItems(projectId: string): Promise<Blob | undefined> {
    if (await this.ensureDbOpen()) {
      return new Promise<Blob | undefined>((resolve, reject) => {
        const transaction = this.db!.transaction([PROJECT_ITEMS_BLOBS]);
        const objectStore = transaction.objectStore(PROJECT_ITEMS_BLOBS);
        const request = objectStore.get(projectId);

        request.onerror = (event) => {
          logger.error(`load loadProdData failed: ${projectId}`, event);
          resolve(undefined);
        };

        request.onsuccess = async (event) => {
          const blob = request.result?.blob;
          if (!blob) {
            resolve(undefined);
          } else {
            const z = new ZipStorageHandler();
            const isValidZip = await z.setBlob(blob);
            if (isValidZip) {
              const p = projectId.indexOf("-snapshot");
              if (p > 0) {
                projectId = projectId.substring(0, p);
              }
              await z.loadProjectItemsFromZip(projectId);
              await z.loadDeletedIds();
              resolve(blob);
            } else {
              resolve(undefined);
            }
          }
        };

        request.onerror = (event) => {
          if (event?.target) {
            logger.log("error: ", event.target);
            resolve(undefined);
          }
        };
      });
    } else {
      return undefined;
    }
  }

  async loadProjectItemsBlob(projectId: string): Promise<Blob | undefined> {
    if (!(await this.ensureDbOpen())) return undefined;
    return new Promise<Blob | undefined>((resolve) => {
      const transaction = this.db!.transaction([PROJECT_ITEMS_BLOBS]);
      const request = transaction.objectStore(PROJECT_ITEMS_BLOBS).get(projectId);
      request.onsuccess = () => resolve(request.result?.blob);
      request.onerror = () => resolve(undefined);
    });
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // Metadata
  ///////////////////////////////////////////////////////////////////////////////////

  async deleteProjectMetadata(projectId: string): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        // delete metadata

        const transaction = this.db!.transaction([PROJECTS], "readwrite");

        const objectStore = transaction.objectStore(PROJECTS);
        const request = objectStore.delete(projectId);

        request.onerror = () => {
          resolve(false);
        };
        request.onsuccess = () => {
          resolve(true);
        };
      });
    } else {
      return false;
    }
  }

  async loadProjectMetadata(projectId: string): Promise<any> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([PROJECTS]);
        const objectStore = transaction.objectStore(PROJECTS);
        const request = objectStore.get(projectId);
        request.onsuccess = () => {
          resolve(request.result);
        };

        request.onerror = (event) => {
          logger.error(`load projectMetadata failed: ${projectId}`, event);
          resolve(undefined);
        };
      });
    } else {
      return false;
    }
  }

  async saveProjectMetadata(projectId: string, data: ProjectMetadata): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([PROJECTS], "readwrite");
        const objectStore = transaction.objectStore(PROJECTS);

        const requestUpdate = objectStore.put(data);

        requestUpdate.onsuccess = () => {
          resolve(true);
        };
        requestUpdate.onerror = (event) => {
          if (event?.target) {
            logger.log("error: ", event.target);
            resolve(false);
          }
        };
      });
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // Projectlist
  ///////////////////////////////////////////////////////////////////////////////////

  async loadProjectList(user: string): Promise<any> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        logger.log("loading Projects");
        const transaction = this.db!.transaction([PROJECTS]);
        const objectStore = transaction.objectStore(PROJECTS);
        const request = objectStore.getAll();

        request.onerror = () => {
          // Handle errors!
          return [];
        };
        request.onsuccess = () => {
          // Do something with the request.result!
          logger.log("loaded data from DB ", request.result);
          resolve(request.result);
        };
      });
    } else {
      return false;
    }
  }

  /**
   * Returns projects whose newest existing local entry is an autobackup.
   * Orphaned metadata without a corresponding ZIP blob is ignored.
   */
  async loadLatestAutobackups(): Promise<any[]> {
    if (!(await this.ensureDbOpen())) return [];

    return new Promise<any[]>((resolve) => {
      const transaction = this.db!.transaction([PROJECTS, PROJECT_ITEMS_BLOBS]);
      const metadataRequest = transaction.objectStore(PROJECTS).getAll();
      const blobsRequest = transaction.objectStore(PROJECT_ITEMS_BLOBS).getAllKeys();

      transaction.oncomplete = () => {
        const blobIds = new Set(blobsRequest.result.map((id) => String(id)));
        const newestByProject = new Map<string, any>();
        const metadataById = new Map<string, any>();

        metadataRequest.result.forEach((metadata: any) => {
          metadataById.set(metadata.id, metadata);
          if (!blobIds.has(metadata.id)) return;

          const snapshotPosition = metadata.id.indexOf("-snapshot");
          const projectId = snapshotPosition > 0 ? metadata.id.substring(0, snapshotPosition) : metadata.mainId || metadata.id;
          const existing = newestByProject.get(projectId);
          if (!existing || this.localProjectTimestamp(metadata) > this.localProjectTimestamp(existing)) {
            newestByProject.set(projectId, metadata);
          }
        });

        const autobackups = [...newestByProject.values()]
          .filter((metadata) => metadata.id.includes("-snapshot-autobackup-"))
          .map((metadata) => {
            if (metadata.name) return metadata;
            const snapshotPosition = metadata.id.indexOf("-snapshot");
            const projectId = snapshotPosition > 0 ? metadata.id.substring(0, snapshotPosition) : metadata.mainId || metadata.id;
            return { ...metadata, name: metadataById.get(projectId)?.name || projectId };
          })
          .sort((left, right) => this.localProjectTimestamp(right) - this.localProjectTimestamp(left));
        resolve(autobackups);
      };
      transaction.onerror = () => resolve([]);
      transaction.onabort = () => resolve([]);
    });
  }

  /** Deletes every local autobackup belonging to a project, including older hidden entries. */
  async deleteProjectAutobackups(projectId: string): Promise<boolean> {
    return this.deleteRelatedProjectEntries(projectId, true);
  }

  /** Deletes every local manual snapshot and autobackup belonging to a project. */
  async deleteProjectSnapshots(projectId: string): Promise<boolean> {
    return this.deleteRelatedProjectEntries(projectId, false);
  }

  private async deleteRelatedProjectEntries(projectId: string, autobackupsOnly: boolean): Promise<boolean> {
    if (!(await this.ensureDbOpen())) return false;

    const belongsToProject = (id: unknown, mainId?: unknown) => {
      const entryId = String(id ?? "");
      const isSnapshot = entryId.startsWith(`${projectId}-snapshot`);
      const isAutobackup = entryId.startsWith(`${projectId}-snapshot-autobackup-`);
      const belongsByMetadata = mainId === projectId && entryId !== projectId;
      return autobackupsOnly ? isAutobackup : isSnapshot || belongsByMetadata;
    };

    return new Promise<boolean>((resolve) => {
      const transaction = this.db!.transaction([PROJECTS, PROJECT_ITEMS_BLOBS], "readwrite");

      const metadataCursor = transaction.objectStore(PROJECTS).openCursor();
      metadataCursor.onsuccess = () => {
        const cursor = metadataCursor.result;
        if (!cursor) return;
        if (belongsToProject(cursor.primaryKey, cursor.value?.mainId)) cursor.delete();
        cursor.continue();
      };

      const blobCursor = transaction.objectStore(PROJECT_ITEMS_BLOBS).openCursor();
      blobCursor.onsuccess = () => {
        const cursor = blobCursor.result;
        if (!cursor) return;
        if (belongsToProject(cursor.primaryKey)) cursor.delete();
        cursor.continue();
      };

      transaction.oncomplete = () => resolve(true);
      transaction.onerror = () => resolve(false);
      transaction.onabort = () => resolve(false);
    });
  }

  private localProjectTimestamp(metadata: any): number {
    const localCopied = metadata?.localCopied ? new Date(metadata.localCopied).getTime() : NaN;
    if (Number.isFinite(localCopied)) return localCopied;

    const marker = metadata?.id?.indexOf("-snapshot-") ?? -1;
    if (marker < 0) return 0;
    const idTimestamp = new Date(metadata.id.substring(marker + "-snapshot-".length).replace("autobackup-", "")).getTime();
    return Number.isFinite(idTimestamp) ? idTimestamp : 0;
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // ProductData Cache
  ///////////////////////////////////////////////////////////////////////////////////

  async saveProdData(id: string, data: any): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([PRODDATACACHE], "readwrite");
        const objectStore = transaction.objectStore(PRODDATACACHE);

        // const data = project.toJSON();
        const requestUpdate = objectStore.put({ id: id, blob: data });

        requestUpdate.onsuccess = () => {
          resolve(true);
        };

        requestUpdate.onerror = (event) => {
          if (event?.target) {
            logger.log("error: ", event.target);
            resolve(false);
          }
        };
      });
    } else {
      return false;
    }
  }

  async loadProdData(id: string): Promise<any> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([PRODDATACACHE]);
        const objectStore = transaction.objectStore(PRODDATACACHE);
        const request = objectStore.get(id);
        request.onsuccess = () => {
          resolve(request.result?.blob);
        };

        request.onerror = (event) => {
          logger.error(`load loadProdData failed: ${id}`, event);
          resolve(undefined);
        };
      });
    } else {
      return false;
    }
  }

  async deleteProdData(id: string): Promise<any> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([PRODDATACACHE], "readwrite");
        const objectStore = transaction.objectStore(PRODDATACACHE);
        const request = objectStore.delete(id);

        request.onsuccess = () => {
          resolve(true);
        };

        request.onerror = () => {
          resolve(false);
        };
      });
    } else {
      return false;
    }
  }

  async clearProductDataCache() {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([PRODDATACACHE], "readwrite");
        const objectStore = transaction.objectStore(PRODDATACACHE);
        const request = objectStore.clear();

        request.onsuccess = () => {
          resolve(true);
        };

        request.onerror = () => {
          resolve(false);
        };
      });
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // ImageData Cache
  ///////////////////////////////////////////////////////////////////////////////////

  async saveImageData(
    id: string,
    data: any,
    metadata?: {
      etag?: string;
      lastModified?: string;
      imageSource?: string;
    },
  ): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([IMAGEDATACACHE], "readwrite");
        const objectStore = transaction.objectStore(IMAGEDATACACHE);

        // const data = project.toJSON();
        const requestUpdate = objectStore.put({ id: id, blob: data, ...metadata, timestamp: Date.now() });

        requestUpdate.onsuccess = () => {
          resolve(true);
        };
        requestUpdate.onerror = (event) => {
          if (event?.target) {
            logger.log("error: ", event.target);
            resolve(true);
          }
        };
      });
    } else {
      return false;
    }
  }

  async loadImageData(id: string): Promise<any> {
    const entry = await this.loadImageDataEntry(id);
    return entry?.blob;
  }

  async loadImageDataEntry(id: string): Promise<any> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([IMAGEDATACACHE]);
        const objectStore = transaction.objectStore(IMAGEDATACACHE);
        const request = objectStore.get(id);
        request.onsuccess = () => {
          resolve(request.result);
        };

        request.onerror = (event) => {
          logger.error(`load loadImageData failed: ${id}`, event);
          resolve(undefined);
        };
      });
    } else {
      return false;
    }
  }

  async deleteImageData(id: string): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([IMAGEDATACACHE], "readwrite");
        const objectStore = transaction.objectStore(IMAGEDATACACHE);
        const request = objectStore.delete(id);

        request.onsuccess = () => {
          resolve(true);
        };

        request.onerror = (event) => {
          logger.error(`delete ImageData failed: ${id}`, event);
          resolve(false);
        };
      });
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // MetaData Cache
  ///////////////////////////////////////////////////////////////////////////////////

  async saveMetaData(id: string, data: any): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([METADATACACHE], "readwrite");
        const objectStore = transaction.objectStore(METADATACACHE);

        // const data = project.toJSON();
        const requestUpdate = objectStore.put({ id: id, metadata: data });

        requestUpdate.onsuccess = () => {
          resolve(true);
        };
        requestUpdate.onerror = (event) => {
          if (event?.target) {
            logger.log("error: ", event.target);
            resolve(true);
          }
        };
      });
    } else {
      return false;
    }
  }

  async loadMetaData(id: string): Promise<any> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([METADATACACHE]);
        const objectStore = transaction.objectStore(METADATACACHE);
        const request = objectStore.get(id);
        request.onsuccess = () => {
          resolve(request.result?.metadata);
        };

        request.onerror = (event) => {
          logger.error(`load loadImageData failed: ${id}`, event);
          resolve(undefined);
        };
      });
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // Voltus CSV Cache
  ///////////////////////////////////////////////////////////////////////////////////

  async saveVoltusData(id: string, rows: any): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([VOLTUSCSVCACHE], "readwrite");
        const objectStore = transaction.objectStore(VOLTUSCSVCACHE);

        const requestUpdate = objectStore.put({ id: id, rows: rows, timestamp: Date.now() });

        requestUpdate.onsuccess = () => {
          resolve(true);
        };
        requestUpdate.onerror = (event) => {
          if (event?.target) {
            logger.log("error: ", event.target);
            resolve(false);
          }
        };
      });
    } else {
      return false;
    }
  }

  async loadVoltusData(id: string, maxAgeMs?: number): Promise<any> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([VOLTUSCSVCACHE]);
        const objectStore = transaction.objectStore(VOLTUSCSVCACHE);
        const request = objectStore.get(id);
        request.onsuccess = () => {
          const record = request.result;
          if (!record || (maxAgeMs && Date.now() - record.timestamp > maxAgeMs)) {
            resolve(undefined);
          } else {
            resolve(record.rows);
          }
        };

        request.onerror = (event) => {
          logger.error(`loadVoltusData failed: ${id}`, event);
          resolve(undefined);
        };
      });
    } else {
      return false;
    }
  }

  async deleteVoltusData(id: string): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        const transaction = this.db!.transaction([VOLTUSCSVCACHE], "readwrite");
        const objectStore = transaction.objectStore(VOLTUSCSVCACHE);
        const request = objectStore.delete(id);

        request.onsuccess = () => {
          resolve(true);
        };

        request.onerror = () => {
          resolve(false);
        };
      });
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////
  //Init
  ///////////////////////////////////////////////////////////////////////////////////

  async initializeDB(): Promise<boolean> {
    return new Promise<any>((resolve, reject) => {
      logger.log("creating db");
      const request = window.indexedDB.open("smartHomeJeannie", VERSION);

      request.onerror = (err) => {
        logger.error("Why didn't you allow my web app to use IndexedDB?!", err);
        resolve(false);
      };

      request.onsuccess = (event: any) => {
        logger.log("setting db");
        this.db = event.target.result;
        resolve(true);
      };

      request.onupgradeneeded = (event) => {
        try {
          const target: any = event.target;
          const database: IDBDatabase = target.result;
          const transaction: IDBTransaction = (event.target as any)?.transaction;

          function createObjectStore(name: string, options?: IDBObjectStoreParameters): IDBObjectStore {
            if (database.objectStoreNames.contains(name)) {
              return transaction.objectStore(name);
            }

            database.objectStoreNames.contains(name);

            return database.createObjectStore(name, options);
          }

          function createIndex(
            store: IDBObjectStore,
            name: string,
            keyPath: string | Iterable<string>,
            options?: IDBIndexParameters,
          ) {
            try {
              //
              // delete old index, if it exists
              // if index does NOT exists, an eror is thrown
              //
              if (store.indexNames.contains(name)) {
                store.deleteIndex(name);
              }
            } catch (ex) {}

            store.createIndex(name, keyPath, options);
          }

          const objectStoreItemsBlobs = createObjectStore(PROJECT_ITEMS_BLOBS, {
            keyPath: "id",
          });

          const objectStoreItems = createObjectStore(PROJECT_ITEMS, {
            keyPath: "id",
          });

          createIndex(objectStoreItems, "projectId", "projectId", {
            unique: false,
          });
          createIndex(objectStoreItems, "parentId", "parentId", {
            unique: false,
          });

          // just for easier findinf in datatbase for debugging .....
          createIndex(objectStoreItems, "className", "className", {
            unique: false,
          });

          ///////////// metadata

          createObjectStore(PROJECTS, {
            keyPath: "id",
          });

          // productData cache
          createObjectStore(PRODDATACACHE, {
            keyPath: "id",
          });

          // productData cache
          createObjectStore(IMAGEDATACACHE, {
            keyPath: "id",
          });

          // productData cache
          createObjectStore(METADATACACHE, {
            keyPath: "id",
          });

          // Voltus CSV cache
          createObjectStore(VOLTUSCSVCACHE, {
            keyPath: "id",
          });

          // pdfStorage cache
          createObjectStore(PDFSTORAGE, {
            keyPath: "id",
          });

          logger.log("Local database created or updated");
        } catch (ex) {
          logger.error("onupgradeneeded", ex);
        }
      };
    });
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // User

  async userIsLoggedIn(): Promise<boolean> {
    return true;
  }

  async login(params: { email: string; password: string }): Promise<any | undefined> {
    return params;
  }

  //////////////////////////////////////////////////////////////

  async loadPdfFile(id: string): Promise<Blob | undefined> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        try {
          const transaction = this.db!.transaction([PDFSTORAGE]);
          const objectStore = transaction.objectStore(PDFSTORAGE);
          const request = objectStore.get(id);
          request.onsuccess = () => {
            resolve(request.result?.blob);
          };

          request.onerror = (event) => {
            logger.error(`load loadImageData failed: ${id}`, event);
            resolve(undefined);
          };
        } catch (ex) {
          logger.error(ex);
        }
      });
    }
    return undefined;
  }

  async savePdfFile(id: string, blob: Blob): Promise<boolean> {
    try {
      if (await this.ensureDbOpen()) {
        return new Promise<any>((resolve, reject) => {
          try {
            const transaction = this.db!.transaction([PDFSTORAGE], "readwrite");
            const objectStore = transaction.objectStore(PDFSTORAGE);

            // const data = project.toJSON();
            const requestUpdate = objectStore.put({ id: id, blob: blob });

            requestUpdate.onsuccess = () => {
              resolve(true);
            };
            requestUpdate.onerror = (event) => {
              if (event?.target) {
                logger.log("error: ", event.target);
                resolve(true);
              }
            };
          } catch (ex) {
            logger.error(ex);
          }
        });
      } else {
        return false;
      }
    } catch (ex) {
      logger.error(ex);
    }
    return false;
  }

  installationCheckId(projectId: string, ownerId: string): string {
    return `I-${projectId}-${ownerId}`;
  }

  async saveInstallationChecks(projectId: string, ownerId: string, item: any): Promise<boolean> {
    if (await this.ensureDbOpen()) {
      return new Promise<any>((resolve, reject) => {
        try {
          item.id = this.installationCheckId(projectId, ownerId);
          item.projectId = projectId;
          item.parentId = ownerId;

          const transaction = this.db!.transaction([PROJECT_ITEMS], "readwrite");

          const objectStore = transaction.objectStore(PROJECT_ITEMS);
          const requestUpdate = objectStore.put(item);

          requestUpdate.onsuccess = () => {
            logger.log(`added installationChecks to DB ${item.id}`);
            resolve(true);
          };

          requestUpdate.onerror = (event) => {
            if (event?.target) {
              logger.log("error: ", event.target);
              resolve(false);
            }
          };
        } catch (ex) {
          logger.error("saveProjectToDB", ex, item);
          resolve(false);
        }
      });
    }
    return false;
  }

  async loadInstallationChecks(projectId: string, ownerId: string): Promise<any | undefined> {
    if (await this.ensureDbOpen()) {
      return new Promise<any | undefined>((resolve, reject) => {
        const id = this.installationCheckId(projectId, ownerId);

        const transaction = this.db!.transaction([PROJECT_ITEMS], "readwrite");
        const objectStore = transaction.objectStore(PROJECT_ITEMS);
        const request = objectStore.get(id);
        request.onsuccess = () => {
          resolve(request.result);
        };

        request.onerror = (event) => {
          logger.error(`load loadInstallationChecks failed: ${id}`, event);
          resolve(undefined);
        };
      });
    } else {
      return undefined;
    }
  }
}

export default function getLocalStorageHandler(): LocalStorageHandler {
  return new LocalStorageHandler();
}
